<template>
  <div class="dropdown">
    <button v-if="user" class="btn btn-secondary dropdown-toggle loginbutton" type="button" id="logged" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{user.name}}</button>
    <button v-else class="btn btn-secondary dropdown-toggle bg-warning loginbutton" type="button" id="login" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Login</button>
    <div v-if="user" class="dropdown-menu dropdown-menu-right" aria-labelledby="logged">
      <!-- <a class="dropdown-item">Test</a> -->
      <router-link v-if="user.accessLevel == 1" class="dropdown-item" :to="{ name: 'UserProjects' }">Progetti</router-link>
      <router-link v-if="user.accessLevel == 0" :to="{ name: 'Dashboard' }" class="dropdown-item">Dashboard</router-link>
      <button @click="logOut" class="dropdown-item">Log Out</button>
    </div>

    <div v-else class="dropdown-menu dropdown-menu-right tolog__dropdown-menu" aria-labelledby="login">
      <a class="d-flex justify-content-between dropdown-item" v-on:click="signInWithGoogle" href="#"> Google
        <i class="float-right fab fa-google"></i>
      </a>
    </div>
  </div>
</template>

<script>
import router from '@/router'
import { getCurrentUser, permissions } from '@/helpers'
import { firebase, database } from '@/firebase'


export default {
  name: 'LoginButton',
  data() {
    return {
      user: null
    }
  },
  created() {
    
    
    if (firebase.auth().currentUser) {
      getCurrentUser(firebase.auth().currentUser.email).then(res => {
        this.user = res
      })
    }
    else
      this.user = null
  },
  methods: {
    signInWithGoogle: function() {
      let provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider)
        .then(result => {
          if (result.additionalUserInfo.isNewUser) {
            database.collection('Users').doc(result.user.email).set({
              name: result.user.displayName,
              email: result.user.email,
              accessLevel: permissions.guest
            })
          }

          getCurrentUser(result.user.email).then(user => {
            this.user = user

            if (user.accessLevel == permissions.admin)
              router.push('/admin/project/list')
            else if (user.accessLevel == permissions.inventor)
              router.push('/user/projects')
            else if (user.accessLevel == permissions.guest)
              router.push('/')
          })
        })
      },
    logOut: function() {
      firebase.auth().signOut().then(() => {
        this.user = null
        router.push('/')
      }).catch(error => alert(`Oops! ${error.message}`))
    }
  }
};
</script>

<style scoped>
.tolog__dropdown-menu {
  width: 200px;
}

.loginbutton {
  background-color: #d6780d;
  border: none;
  color: rgb(255, 255, 255);
}
</style>



// WEBPACK FOOTER //
// src/components/LoginButton.vue